import React, { createContext, useContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Check localStorage for saved theme, default to 'light'
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme || "light";
  });

  const [identity, setIdentity] = useState(() => {
    return localStorage.getItem("identity") || "teacher";
  });

  useEffect(() => {
    // Update the data-theme attribute on the document root
    document.documentElement.setAttribute("data-theme", theme);
    // Save to localStorage
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    // Apply role-based identity to document root so all CSS [data-identity] selectors work
    document.documentElement.setAttribute("data-identity", identity);
    localStorage.setItem("identity", identity);
  }, [identity]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  const switchIdentity = (newIdentity) => {
    setIdentity(newIdentity);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, identity, switchIdentity }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
